import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'employees',
        pathMatch: 'full',
    },

    // ─── Таблица сотрудников ──────────────────────────────────────────────────
    {
        path: 'employees',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./features/employees/employee-table/employee-table.component')
                .then((m) => m.EmployeeTableComponent),
    },

    // ─── Личный кабинет ───────────────────────────────────────────────────────
    {
        path: 'profile',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./features/profile/profile-shell/profile-shell.component')
                .then((m) => m.ProfileShellComponent),
        children: [
            {
                path: '',
                redirectTo: 'settings',
                pathMatch: 'full',
            },
            {
                // Вкладка "НАСТРОЙКИ" — смена пароля (все роли)
                path: 'settings',
                loadComponent: () =>
                    import('./features/profile/change-password/change-password.component')
                        .then((m) => m.ChangePasswordComponent),
            },
            {
                // Вкладка "АДМИНИСТРИРОВАНИЕ" — только admin и superadmin
                path: 'admin',
                canActivate: [roleGuard(['admin', 'superadmin'])],
                children: [
                    {
                        path: '',
                        redirectTo: 'users',
                        pathMatch: 'full',
                    },
                    {
                        path: 'users',
                        loadComponent: () =>
                            import('./features/profile/admin/user-list/user-list.component')
                                .then((m) => m.UserListComponent),
                    },
                ],
            },
        ],
    },

    // ─── Fallback ─────────────────────────────────────────────────────────────
    {
        path: '**',
        redirectTo: 'employees',
    },
];